export const OTP_LENGTH = 6

export interface LoginRegistrationOneTimePasswordInputFormData {
  fcSolution: string
  password: string
}

export const validateOneTimePassword = (
  value: string,
  missingErrorMessage: string,
  minimumLengthErrorMessage: string,
): string | true => {
  if (!value) {
    return missingErrorMessage
  }

  return value.replace(' ', '').length >= OTP_LENGTH
    ? true
    : minimumLengthErrorMessage
}
